<form
  class="filter-bar"
  [formGroup]="form"
  aria-label="Filtros"
  (ngSubmit)="buscar()"
>
  @for (field of fields(); track field.key) {
    @if (field.type === 'text') {
      <div class="filter-bar__field">
        <label class="filter-bar__label" [for]="'filter-' + field.key">
          {{ field.label }}
        </label>
        <input
          [id]="'filter-' + field.key"
          type="search"
          class="filter-bar__control"
          [formControlName]="field.key"
          [placeholder]="field.placeholder ?? ''"
          autocomplete="off"
          [attr.data-testid]="'filter-' + field.key"
        />
      </div>
    }

    @if (field.type === 'select') {
      <div class="filter-bar__field">
        <label class="filter-bar__label" [for]="'filter-' + field.key">
          {{ field.label }}
        </label>
        <select
          [id]="'filter-' + field.key"
          class="filter-bar__control"
          [formControlName]="field.key"
          [attr.data-testid]="'filter-' + field.key"
        >
          @for (option of field.options ?? []; track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>
    }

    @if (field.type === 'date') {
      <div class="filter-bar__field">
        <label class="filter-bar__label" [for]="'filter-' + field.key">
          {{ field.label }}
        </label>
        <input
          [id]="'filter-' + field.key"
          type="date"
          class="filter-bar__control"
          [formControlName]="field.key"
          [attr.data-testid]="'filter-' + field.key"
        />
      </div>
    }

    @if (field.type === 'daterange') {
      <div class="filter-bar__field filter-bar__field--daterange">
        <span
          class="filter-bar__label"
          [id]="'filter-' + field.key + '-group-label'"
        >
          {{ field.label }}
        </span>
        <div
          class="filter-bar__daterange-row"
          role="group"
          [attr.aria-labelledby]="'filter-' + field.key + '-group-label'"
        >
          <label class="visually-hidden" [for]="'filter-' + field.key">
            Início do período
          </label>
          <input
            [id]="'filter-' + field.key"
            type="date"
            class="filter-bar__control"
            [formControlName]="field.key"
            [attr.data-testid]="'filter-' + field.key"
          />
          <span class="filter-bar__period-separator" aria-hidden="true">até</span>
          <label class="visually-hidden" [for]="'filter-' + (field.keyTo ?? '')">
            Fim do período
          </label>
          <input
            [id]="'filter-' + (field.keyTo ?? '')"
            type="date"
            class="filter-bar__control"
            [formControlName]="field.keyTo ?? ''"
            [attr.data-testid]="'filter-' + (field.keyTo ?? '')"
          />
        </div>
      </div>
    }
  }

  <div class="filter-bar__actions">
    <button
      type="submit"
      class="btn-primary btn-toolbar"
      data-testid="filter-buscar"
    >
      Buscar
    </button>
    <button
      type="button"
      class="btn-secondary btn-toolbar"
      data-testid="filter-limpar"
      (click)="limpar()"
    >
      Limpar
    </button>
  </div>
</form>
